export default __webpack_public_path__ + "3f55868af536447c505cf168fc22861d.png";